import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=31b4ae50&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4ae50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31b4ae50')) {
      api.createRecord('31b4ae50', component.options)
    } else {
      api.reload('31b4ae50', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=31b4ae50&scoped=true&", function () {
      api.rerender('31b4ae50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29oJ7h50f39IZ/JS/comp/SearchFilterTokens.vue"
export default component.exports